import React from 'react'
import { Avatar, IconButton, SwipeableDrawer, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { MenuSvg } from '../../../assets/svg/menu-svg'
import { selectHeaderAvatarSrc, selectUser } from '../../../store/auth/selectors'
import { useAppHeaderRightMenuStyles } from '../app-header-right-menu/app-header-right-menu.styles'
import { useAppHeaderDrawer } from './app-header-drawer.hook'
import { useAppHeaderDrawerStyles } from './app-header-drawer.styles'
import { MenuForAuthenticated } from './menu-for-authenticated'
import { MenuForNotAuthenticated } from './menu-for-not-authenticated'
import { MenuUniversal } from './menu-universal'

export const AppHeaderDrawer: React.FC = (): React.ReactElement => {
  const { isOpened, onOpenHandler, onCloseHandler, onHamburgerClickHandler } =
    useAppHeaderDrawer()

  const classesRightMenu = useAppHeaderRightMenuStyles()
  const classes = useAppHeaderDrawerStyles()
  const user = useSelector(selectUser)
  const avatarSrc = useSelector(selectHeaderAvatarSrc)

  return (
    <>
      <Link
        onClick={onHamburgerClickHandler}
        to="/"
        className={[classesRightMenu.link, classes.hamburger].join(' ')}
      >
        <MenuSvg />
      </Link>
      <SwipeableDrawer
        anchor="right"
        open={isOpened}
        onClose={onCloseHandler}
        onOpen={onOpenHandler}
        classes={{ paper: classes.drawerPaper }}
        ModalProps={{
          BackdropProps: {
            className: classes.backdropBlur,
          },
        }}
      >
        <div className={classes.listHolder}>
          {/* Header with close button */}
          <div className={classes.drawerHeader}>
            <IconButton 
              onClick={onCloseHandler} 
              className={classes.closeButton}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
          
          {/* User profile block - only show for authenticated users */}
          {!!user.userId && (
            <div className={classes.userProfileBlock}>
              <Avatar
                className={classes.userAvatar}
                src={`${avatarSrc}?${Date.now()}`}
              />
              <div className={classes.userInfo}>
                <Typography className={classes.userName}>
                  {user.name}
                </Typography>
                <Typography className={classes.userEmail}>
                  {user.email}
                </Typography>
              </div>
            </div>
          )}
          
          <div className={classes.list}>
            {user.userId ? <MenuForAuthenticated closeDrawer={onCloseHandler}/> :
              <MenuForNotAuthenticated closeDrawer={onCloseHandler}/>}
          </div>
          <div className={classes.listBottom}>
            <MenuUniversal/>
          </div>
        </div>
      </SwipeableDrawer>
    </>
  )
}
